import { SearchComponent } from "@/App/Tenants/Search";
import { CreateLoaderTable } from "@/components/Loaders";
import { Main } from "@/components/Main";
import { useEffect, useState } from "react";
import { ApiDataProps } from "../Tenants";
import { TypePageActions } from "../Plans";
import { AddBtn } from "@/App/Units/Add";
import { TableData } from "@/App/Units/Table";
import { getUnitiesData, searchUnitiesData } from "@/Api/unities";
import { useAuth } from "@/hooks/auth";
import { TypeUser } from "@/types/userType";
import { usePermissions } from "@/hooks/usePermissions";
import { If } from "@/components/If";
import { Building2 } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";

export type TableDataProps = {
  id: number;
  uuid: string;
  name: string;
  image: string | null;
  is_active: boolean;
  tenant_id: number;
  created_at: string;
  updated_at: string;
  deleted_at: string | null;
};

export const PageList = () => {
  const [listData, setListData] = useState({} as ApiDataProps<TableDataProps>);
  const [state, setState] = useState("loading");
  const { hasPermission } = usePermissions();
  const user = useAuth();
  const unityId = user?.user?.unity?.[0]?.id || "";
  const userTypeUnity = user?.user?.user_type_id == TypeUser.unity_responsible;
  useEffect(() => {
    (async () => {
      const { data } = await getUnitiesData(1, unityId);
      setListData(data?.response);
      setState("production");
    })();
  }, []);

  const pageActions: TypePageActions = {
    next: async () => {
      if (listData?.current_page < listData?.last_page) {
        setState("loading");

        const { data } = await getUnitiesData(
          listData?.current_page + 1,
          unityId
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    previous: async () => {
      if (listData?.current_page > 1) {
        setState("loading");

        const { data } = await getUnitiesData(
          listData?.current_page - 1,
          unityId
        );
        setListData(data.response);
        setState("production");
      }
      return;
    },
    lastPage: async () => {
      if (listData?.current_page !== listData?.last_page) {
        setState("loading");

        const { data } = await getUnitiesData(listData?.last_page, unityId);
        setListData(data?.response);
        setState("production");
      }
      return;
    },
  };

  return (
    <Main>
      <If condition={hasPermission("view-units-list")}>
        <PageHeader
          icon={Building2}
          title="Unidades"
          description="Gerencie suas unidades de venda"
        >
          <If condition={hasPermission("create-unit")}>
            <AddBtn updateFront={setListData} />
          </If>
        </PageHeader>
        <div className="flex flex-col gap-3">
          {!userTypeUnity ? (
            <SearchComponent
              updateFront={setListData}
              setState={setState}
              funcSearch={searchUnitiesData}
              placeholder="Pesquisar unidades"
            />
          ) : null}
          {state === "loading" ? (
            <CreateLoaderTable cols={4} lines={6} />
          ) : (
            <TableData
              dataApi={listData}
              pageActions={pageActions}
              updateFront={setListData}
            />
          )}
        </div>
      </If>
    </Main>
  );
};
